// extracted by mini-css-extract-plugin
module.exports = {"custom":"DateRange_custom__nj8SM","picker":"DateRange_picker__3F3uV","close":"DateRange_close__2LAKm"};